import {Component, ViewChild, EventEmitter} from '@angular/core';
import {MatPaginator, MatDialog, MatSort} from '@angular/material';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import {generalService} from '../../services/general.service';
import { DataService } from '../../utils/data.service';
import { modalComponent } from '../../utils/modal/modal.component';
import {ItemSubFamily} from '../../models/item-subfamily';
import {DataSourceGrid,datosGrid} from '../../utils/sourceGrid.component';
import { FormGroup, FormBuilder, FormControl, Validators  } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'item-subfamily-add-edit',
  styleUrls: [],
  templateUrl: 'item-subfamily-add-edit.component.html',
  providers: [generalService]
})

export class ItemSubFamiliaAddEditComponent {
  // --------- VARIABLES MATERIALES -------------//
  subfamilyAgregar: FormGroup;
  public subfamily:ItemSubFamily;
  public userData: any = JSON.parse(sessionStorage.getItem('user'));
  public isUpdate:boolean=false;
  public itemSubFamilyID:any; 

  private readonly SUCCESS_MSG = 'Se ha guardado exitosamente!';
  private readonly UPDATE_MS = 'Se actualizó exitosamente!';
  
  //----------- Listas (mat-select)-------------//
  public familiaLista:any=[];
  public subfamiliaLista:any=[];

  public lstFamilyFiltradas=[];

  constructor(private _generalService: generalService, public dialog: MatDialog, public dataService: DataService/*, private sanitizer: DomSanitizer*/, private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute) {
    this.subfamily = new ItemSubFamily();
    this.itemSubFamilyID = this.route.snapshot.paramMap.get('id');    
  }

  async ngOnInit() {
    this.buildForm();
    await this.cargarPantalla();
    this.validateRoute();
    this.subfamily.companyId = this.userData.COMPANY_ID;

  }

  buildForm(){
    this.subfamilyAgregar = this.formBuilder.group({
        subfamilyCtrl: this.formBuilder.control(null, Validators.required),
        familyCtrl: this.formBuilder.control(null, Validators.required),
      });
  }

  cargarPantalla(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.requestGet("venta/cargarInformacionAgregarVenta?idUsuario=" + this.userData.USER_ID).subscribe(
        (result) => {
            var dataTemp: any = JSON.parse(result);
            // Tipo de venta
            //this.lstTipoVenta = dataTemp.Table1;
            // ----------------------   COMPRA   ------------------------ //
            // Familias
            this.familiaLista = dataTemp.Table2;
            this.subfamily.lstFamily = this.familiaLista;                        
          
            resolve();
        },
        (error) => {
            const errorMsj =  error as any;
            console.error(errorMsj);
            reject();
        }
    );

    });
  }

  validateRoute() {
    if (this.itemSubFamilyID === 'N') {
      this.isUpdate = false;      
    } else if (parseInt(this.itemSubFamilyID)) {
      this.isUpdate = true;
      this.consultItem(this.itemSubFamilyID);
    } else {
      this.router.navigate(['item-subfamily/N']);
    }
  }

  consultItem(itemSubFamilyID:any){
    var params = {
      userID: this.userData.USER_ID,
      ItemSubFamilyId: itemSubFamilyID
    }
    this._generalService.metodoCallParams(params, 'itemSubFamily/consultaSubFamily/')
      .subscribe(products => {
        var result = JSON.parse(products);
        if (result.length > 0) {
          this.subfamily.itemSubFamilyId = result[0].ITEM_SUBFAMILY_ID
          this.subfamily.itemFamilyId = result[0].ITEM_FAMILY_ID;
          this.subfamily.name = result[0].NAME;
          this.subfamily.companyId = result[0].COMPANY_ID;
        } 
      }, error => {
        // Custom error handler
      });
  }

  filtrarFamily(subfamily: ItemSubFamily) {
    let arr: any[];
    if (subfamily.searchFamily) {
        arr = subfamily.lstFamilyFiltradas.filter((obj) => {
            return obj.NAME.indexOf(subfamily.searchFamily) > -1 || ((obj.SKU) ? obj.SKU : '').indexOf(subfamily.searchFamily) > -1 || ((obj.BARCODE) ? obj.BARCODE : '').indexOf(subfamily.searchFamily) > -1;
        });
    } 
    else {
        arr = subfamily.lstFamily;
    }
    subfamily.lstFamilyFiltradas = arr;
  }
  
  agregar() {
    let tipo = 'agregar';
    let metodo = 'itemSubFamily/insertItemSubFamily/';
    
    var params = {
      itemSubFamiliId: undefined,
      NAME:this.subfamily.name, 
      ItemFamilyId: this.subfamily.itemFamilyId,
      CompanyId : this.subfamily.companyId
    };

    this._generalService.metodoCallParamsPutPost(tipo, params, metodo).subscribe(
      (result) => {
        if (result == '') {
          this._generalService.toastCall(this.SUCCESS_MSG);
        } else {
          this.dataService.guardado = true;
        }
      },
      (error) => {
        const errorMsj =  error as any;
        console.log(errorMsj);
      }
    );
  }

  update() {
    if(this.isUpdate){
      //this.product.loacs = sessionStorage.getItem("acslo");
      var params = {
        ItemSubFamilyId: this.subfamily.itemSubFamilyId,
        name:this.subfamily.name, 
        ItemFamilyId: this.subfamily.itemFamilyId,
        CompanyId: this.subfamily.companyId
      };
      this._generalService.metodoCallParams(params, 'itemSubFamily/updateItemSubFamily/')
        .subscribe(result => {
          if (result == '') {
            this._generalService.toastCall(this.UPDATE_MS)
          } else {
            this.dataService.guardado = true;
          }
        }, error => {
          //Custom error handler
          const errorMsj =  error as any;
          console.log(errorMsj);
        });
    }
  }

  regresar(){
    this.router.navigate(['app/item-subfamily']);
  }


}//fin de export class




// WEBPACK FOOTER //
// ./src/app/subfamilia/add-edit/item-subfamily-add-edit.component.ts